import React, { useEffect } from 'react';
import './App.css';
import Logout from './views/Logout';
import LoggedViews from './views/LoggedViews';
import GuestViews from './views/GuestViews';
import PublicShopViews from './views/PublicShopViews';
import { Route, Switch, withRouter } from 'react-router';
import pages from './routes/pages';
import useCleanSW from './hooks/useCleanSW';
import { isLogged } from './helpers/user/authorization';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { useDispatch } from 'react-redux';
import { displayProductList } from 'store/actions/ui.actions';
import { useMatomoTracking } from './hooks/useMatomoTracking';
import useScrollToTop from 'hooks/useScrollToTop';
import usePublicShop from './hooks/usePublicShop';

const App = () => {
  useCleanSW();
  useMatomoTracking();
  useScrollToTop();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('mobile');
  const { isPublicShop } = usePublicShop();

  useEffect(() => {
    if (isMobile) {
      dispatch(displayProductList('List'));
    }
    if (!isPublicShop) {
      dispatch(displayProductList('Mosaique'));
    }
    dispatch(displayProductList('Mosaique'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isPublicShop]);

  return (
    <Switch>
      {isLogged && <Route component={LoggedViews} />}
      <Route exact path={pages.LOGOUT.path} component={Logout} />
      <Route path={pages.PUBLIC_SHOP_HOME.path} component={PublicShopViews} />
      <Route component={GuestViews} />
    </Switch>
  );
};

export default withRouter(App);
